<template>
  <div class="inputField" :style="isIphone?'':'padding-bottom:8px'">
    <div class="input-box">
      <input type="text" maxlength="150" v-model="message" @keyup.enter="send" ref="input-msg" @focus="windowFocus" @blur="blurEnter()">
    </div>
    <div class="icon-box" @click="send">
      <!-- <i class="cubeic-navigation"></i> -->
      <img src="@/assets/sendIcon.6755fa82.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: '', 
    }
  },
  mounted() {
    // this.$refs['input-msg'].focus()
  },
  computed:{
    isIphone(){
      console.log(navigator.userAgent,12312313);
      return /iphone/gi.test(navigator.userAgent)&& (screen.height >= 812)
    }
  },
  methods: {
    send() {
      this.$emit('sendMsg', this.message)
      this.message = '';
    },
    windowFocus() {
      this.$emit('inputFocus')
    },
    blurEnter() {
      window.scrollTo(0,0)
    }
  }
}
</script>

<style lang="scss">
.inputField {
  // height: 50px;
  width: 100%;
  background: #F6F6F6;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding-bottom: 34px;
  .input-box {
    width: calc(100vw - 64px);
    margin-left: 12px;
    text-align: center;
    input {
      font-size: 14px;
      color: #1A1A1A;
      padding:0 13px;
      width: calc(100vw - 64px);
      height: 40px;
      background-color: #FFFFFF;
      border: 1px solid #EDEDED;
      outline: none;
      border-radius: 4px;
    }
  }
  .icon-box {
    font-size: 24px;
    width: 15%;
    text-align: center;
    color: #909399;
    i {
      padding-right: 6px;
    }
    img{
      width: 28px;
      height: 28px;
      position: relative;
      top: 3px;
    }
  }
}
</style>